"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Logger_instances, _Logger_moduleName, _Logger_loggingLevel, _Logger_transactionId, _Logger_loggingFunction, _Logger_debug, _Logger_info, _Logger_warn, _Logger_error, _Logger_createLoggers;
Object.defineProperty(exports, "__esModule", { value: true });
exports.logger = exports.Logger = void 0;
const LEVEL = {
    DEBUG: { prefix: "DEBUG", level: 3 },
    INFO: { prefix: "INFO", level: 2 },
    WARN: { prefix: "WARN", level: 1 },
    ERROR: { prefix: "ERROR", level: 0 }
};
const isBelow = (loglevel, test) => {
    return test.level <= loglevel.level;
};
const findLevel = (levelString) => {
    return levelString ? LEVEL[levelString] : undefined;
};
const getCurrentLevel = (modulename) => {
    return findLevel(process.env["log_" + modulename]) || findLevel(process.env["log"]) || LEVEL.INFO;
};
const objToString = (o) => {
    if (!o)
        return "null";
    try {
        return JSON.stringify(o);
    }
    catch (e) {
        return o.toString();
    }
};
const log = (module, type, transactionId, loggingFunction, ...params) => {
    let prefix = `[${type}]\t[${module}]\t`;
    if (transactionId) {
        prefix += `transactionId=${transactionId}\t`;
    }
    const suffix = params
        .map(p => (typeof p === "object" && !(p instanceof Error)) ? objToString(p) : p)
        .join("\t");
    loggingFunction(prefix + suffix);
};
const makeLogFunctionForLevel = (modulename, loggingLevel, level, transactionId, loggingFunction) => {
    if (isBelow(loggingLevel, level)) {
        if (!loggingFunction) {
            // eslint-disable-next-line no-console
            loggingFunction = (msg) => console.log(msg);
        }
        return log.bind(null, modulename, level.prefix, transactionId, loggingFunction);
    }
    else {
        return () => {
            //null function
        };
    }
};
class Logger {
    constructor(moduleName, loggingLevel, transactionId, loggingFunction) {
        _Logger_instances.add(this);
        _Logger_moduleName.set(this, void 0);
        _Logger_loggingLevel.set(this, void 0);
        _Logger_transactionId.set(this, void 0);
        _Logger_loggingFunction.set(this, void 0);
        // Log functions
        _Logger_debug.set(this, void 0);
        _Logger_info.set(this, void 0);
        _Logger_warn.set(this, void 0);
        _Logger_error.set(this, void 0);
        __classPrivateFieldSet(this, _Logger_moduleName, moduleName, "f");
        __classPrivateFieldSet(this, _Logger_loggingLevel, loggingLevel, "f");
        __classPrivateFieldSet(this, _Logger_transactionId, transactionId, "f");
        __classPrivateFieldSet(this, _Logger_loggingFunction, loggingFunction, "f");
        __classPrivateFieldGet(this, _Logger_instances, "m", _Logger_createLoggers).call(this, moduleName, loggingLevel, transactionId, loggingFunction);
    }
    /**
     * log with debug level
     * @param {Messages} messages - the message to log
     */
    debug(...messages) {
        __classPrivateFieldGet(this, _Logger_debug, "f").call(this, ...messages);
    }
    /**
     * log with info level
     * @param {Messages} messages - the message to log
     */
    info(...messages) {
        __classPrivateFieldGet(this, _Logger_info, "f").call(this, ...messages);
    }
    /**
     * log with warning level
     * @param {Messages} messages - the message to log
     */
    warn(...messages) {
        __classPrivateFieldGet(this, _Logger_warn, "f").call(this, ...messages);
    }
    /**
     * log with error level
     * @param {Messages} messages - the message to log
     */
    error(...messages) {
        __classPrivateFieldGet(this, _Logger_error, "f").call(this, ...messages);
    }
    /**
     * Sets a transaction prefix on the logged message (Example: [INFO] [moduleName] transactionId=xxx)
     * @param {string} transactionId - the transactionId to add as a prefix
     * @returns a logger that uses the passed transaction id
     */
    setTransactionId(transactionId) {
        __classPrivateFieldSet(this, _Logger_transactionId, transactionId, "f");
        __classPrivateFieldGet(this, _Logger_instances, "m", _Logger_createLoggers).call(this, __classPrivateFieldGet(this, _Logger_moduleName, "f"), __classPrivateFieldGet(this, _Logger_loggingLevel, "f"), transactionId, __classPrivateFieldGet(this, _Logger_loggingFunction, "f"));
        return this;
    }
    /**
     * Sets a logging function (determines where log messages will be printed to)
     * @param loggingFunction function to log messages
     * @returns a logger that uses the specified logging function
     */
    setLoggingFunction(loggingFunction) {
        __classPrivateFieldSet(this, _Logger_loggingFunction, loggingFunction, "f");
        __classPrivateFieldGet(this, _Logger_instances, "m", _Logger_createLoggers).call(this, __classPrivateFieldGet(this, _Logger_moduleName, "f"), __classPrivateFieldGet(this, _Logger_loggingLevel, "f"), __classPrivateFieldGet(this, _Logger_transactionId, "f"), loggingFunction);
        return this;
    }
}
exports.Logger = Logger;
_Logger_moduleName = new WeakMap(), _Logger_loggingLevel = new WeakMap(), _Logger_transactionId = new WeakMap(), _Logger_loggingFunction = new WeakMap(), _Logger_debug = new WeakMap(), _Logger_info = new WeakMap(), _Logger_warn = new WeakMap(), _Logger_error = new WeakMap(), _Logger_instances = new WeakSet(), _Logger_createLoggers = function _Logger_createLoggers(moduleName, loggingLevel, transactionId, loggingFunction) {
    __classPrivateFieldSet(this, _Logger_debug, makeLogFunctionForLevel(moduleName, loggingLevel, LEVEL.DEBUG, transactionId, loggingFunction), "f");
    __classPrivateFieldSet(this, _Logger_info, makeLogFunctionForLevel(moduleName, loggingLevel, LEVEL.INFO, transactionId, loggingFunction), "f");
    __classPrivateFieldSet(this, _Logger_warn, makeLogFunctionForLevel(moduleName, loggingLevel, LEVEL.WARN, transactionId, loggingFunction), "f");
    __classPrivateFieldSet(this, _Logger_error, makeLogFunctionForLevel(moduleName, loggingLevel, LEVEL.ERROR, transactionId, loggingFunction), "f");
};
/**
 * Create a logger. The logger contains the following methods:<br>
 * <ul>
 *     <li><code>debug(msg)</code> - print a message with debug level (if enabled for logger)
 *     <li><code>info(msg)</code> - print a message with info level (if enabled for logger)
 *     <li><code>warn(msg)</code> - print a message with warn level (if enabled for logger)
 *     <li><code>error(msg)</code> - print a message with warn level (if enabled for logger)
 *     <li><setTransactionId(id)</code> - returns a new logger. Each message printed in that logger will start with 'transactionId=${id}'
 *     (assuming id has a value)
 * </ul>
 * @param {string} moduleName - A prefix for every log line (Example: [INFO] [moduleName] ...)
 * @return {Logger} a logger object used for logging
 */
const logger = (moduleName) => {
    const loggingLevel = getCurrentLevel(moduleName);
    return new Logger(moduleName, loggingLevel, undefined, undefined);
};
exports.logger = logger;
//# sourceMappingURL=logger.js.map